module.exports = __webpack_public_path__ + "img/left.7c3ed3d8.png";